import React from 'react';
import CategoryLandingPage from './CategoryLandingPage';
import { holidayConfig } from '../configs/categoryLandings';

export default function HolidayLandingPage() {
  return <CategoryLandingPage config={holidayConfig} />;
}
